"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _types = require("../../util/types");

var _hooks = require("../../util/hooks");

var _OutsideClickWrapper = _interopRequireDefault(require("../OutsideClickWrapper/OutsideClickWrapper"));

require("./DropDown.scss");

require("./DropDownDark.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Option = function Option(_ref) {
  var option = _ref.option,
      selection = _ref.selection,
      setSelection = _ref.setSelection,
      setOpen = _ref.setOpen,
      tooltipInText = _ref.tooltipInText;
  var refTooltip = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
    className: "gcl-dropdown-item ".concat(option === selection ? '--selected' : ''),
    key: option.id,
    onClick: function onClick() {
      setSelection(option);
      setOpen(false);
    }
  }, tooltipInText ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "tooltipInText",
    ref: option.tooltiptext ? refTooltip : null
  }, option.text) : /*#__PURE__*/_react["default"].createElement("span", null, option.text), option.icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(option.icon),
    ref: refTooltip
  })), option.tooltiptext && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: refTooltip,
    autohide: false,
    trigger: 'hover'
  }, option.tooltiptext));
};

var DropDown = function DropDown(_ref2) {
  var options = _ref2.options,
      onSelect = _ref2.onSelect,
      title = _ref2.title,
      tabIndex = _ref2.tabIndex,
      error = _ref2.error,
      errorMessage = _ref2.errorMessage,
      autoTrigger = _ref2.autoTrigger,
      defaultIndex = _ref2.defaultIndex,
      disabled = _ref2.disabled,
      noDefault = _ref2.noDefault,
      required = _ref2.required,
      _ref2$indexWillChange = _ref2.indexWillChange,
      indexWillChange = _ref2$indexWillChange === void 0 ? false : _ref2$indexWillChange,
      overflow = _ref2.overflow,
      tooltipInText = _ref2.tooltipInText;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(autoTrigger),
      _useState4 = _slicedToArray(_useState3, 2),
      trigger = _useState4[0],
      setTrigger = _useState4[1];

  var _useState5 = (0, _react.useState)(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      selection = _useState6[0],
      setSelection = _useState6[1];

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  (0, _react.useEffect)(function () {
    trigger && onSelect(selection);
  }, [selection]);
  (0, _react.useEffect)(function () {
    if (noDefault) return;
    var selected = defaultIndex && options[defaultIndex] ? options[defaultIndex] : options[0];
    setSelection(selected);
  }, [JSON.stringify(options)]);
  (0, _react.useEffect)(function () {
    if (noDefault) return;

    if (indexWillChange) {
      var selected = defaultIndex && options[defaultIndex] ? options[defaultIndex] : options[0];
      setSelection(selected);
      setTrigger(false);
    }
  }, [defaultIndex]);
  /* const ref = useRef();
  useEffect(() => {
  	if (overflow) {
  		const onScroll = (event) => {
  			console.log('scroll', ref.current, ref.current.refs)
  			if (ref.current && !ref.current.contains(event.target)) {
  				setOpen(false);
  			}
  		}
  		document.addEventListener('scroll', onScroll, true);
  		return () => document.removeEventListener('scroll', onScroll, true);
  	}
  }, [overflow]); */

  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Dropdown, {
    isOpen: isOpen,
    toggle: toggle,
    disabled: disabled,
    className: "gcl-dropdown ".concat(disabled ? '--disabled' : '', " ").concat(error ? '--error' : '', " ").concat(isOpen ? '--focus' : '')
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    tabIndex: tabIndex,
    className: "gcl-dropdown-header",
    tag: "div",
    onClick: function onClick() {
      toggle();
      setTrigger(true);
    }
  }, title ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dropdown-header__title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dropdown-header__placeholder ".concat(selection || isOpen ? '--selected' : '', " ").concat(error ? '--error' : '')
  }, title, required && /*#__PURE__*/_react["default"].createElement("span", {
    className: "required"
  }, "*")), selection && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dropdown-header__selected ".concat(error ? '--error' : '')
  }, selection.text)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dropdown-header__value ".concat(error ? '--error' : '')
  }, selection && selection.text), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dropdown-header__icon ".concat(selection && title ? '--selected' : '', " ").concat(error ? '--error' : '')
  }, isOpen ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon chevron-up"
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon chevron"
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, {
    className: 'gcl-dropdown-list gcl-fader' + (overflow ? ' fixed' : ''),
    flip: false,
    positionFixed: overflow,
    modifiers: overflow ? {
      preventOverflow: {
        boundariesElement: 'window'
      }
    } : {
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    }
  }, options.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: i,
      option: option,
      selection: selection,
      setSelection: setSelection,
      setOpen: setOpen,
      tooltipInText: tooltipInText
    });
  })), error && errorMessage && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-dropdown-error"
  }, errorMessage));
};

DropDown.propTypes = {
  options: _propTypes["default"].arrayOf(_types.dropdownType).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string,
  tabIndex: _propTypes["default"].number,
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].string,
  autoTrigger: _propTypes["default"].bool,
  defaultIndex: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  overflow: _propTypes["default"].bool
};
var _default = DropDown;
exports["default"] = _default;